__turbopack_context__.v({
  "currentPage": "pagination-module-scss-module__7lPRWG__currentPage",
  "ellipsis": "pagination-module-scss-module__7lPRWG__ellipsis",
  "itemList": "pagination-module-scss-module__7lPRWG__itemList",
  "pageCount": "pagination-module-scss-module__7lPRWG__pageCount",
  "pagination": "pagination-module-scss-module__7lPRWG__pagination",
});
